<template>
	<div class="bind-phone">
		<div class="content-card">
			<div class="m-login">
				<van-form ref="vanForm" label-width="44px">
					<div class="form-item">
						<van-field v-model="phone" name="手机号" label="手机号" placeholder="请输入手机号"
							:rules="[{ required: true, message: '请填写手机号' },{validator:phoneValidator,message:'手机号格式不正确'}]">
						</van-field>
						<span class="is-encode">
							<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA6CAYAAAD2mdrhAAAAAXNSR0IArs4c6QAABUNJREFUaEPtmm9sU1UYxp/3tN2IBhRxRFGZISEa/YIJfnBfkLkgGsXEtUXAEKMxC9sdA3cLxJmM+ocha2ssbbeZGAJK0Nt1ihpNJAZDRKOBLDELfhEkmcFkiyawkG3del5zhyXb6J97b++1W8L52vM+7/O777nnnHtOCfO8kZP+Ow9qtSCMBhT/T07lcQSgXdMqFg3RXgbvBpMkgTevDA10BIPBSbtBbAeIJLQ1UlICwEMzzBL6mWlbQPH+bCeEbQCRRO+KjOT9BHgB5NOVxPjYs0C0bX+1/k87QEoGCMVS1SC5B4yXAVQYMcXAmAC6J3myc3fzpktGYvL1sQwQ7up9hDNoAXgzAI9FE+PEOCJlJhpoeWHAioYpgI7EV4vdPOonxlYANVYS5olhZpwSREc88pbe7dufvmJUuyDAux8eX+geG1sNuGqYsQ7MNSC4jYpb7JcG+DRIfAvO/MiLbj8b2Prk1bxD6MD7vSuFizcywy2IFjC4CsB9AK8EqLrAC2nRn+kwCeAiM36HoEEChlnyOBEmAfERhROpDSzlcdOycyCASNTeBChnIeZ9BZj5iXk9hG4ClHP867nnfQVcLtf8fgfmFgDREIDLYH0HYKzNIQD6YGSpbA76/elwPNXALLuNIMwJAAZ1BRRvk/5OZk2HY8khBvQ9WcFWdoBc5iMR7Q5ZQfpHTmUxAALqyraQ5TIfjX5dOeG6+jkz1hczr/9eNoB85tOuq5+B8ZQR82UDsMt8WQDsNG8JgBlpAk4w4R4CVhkt9dSyn2O20ce82WEzPafZd0ACYq2q1J/SRTrjyXZi7DUC4YR5KxX4Q1V8K6YbDsWSbwB4qxCEU+atAIy5PGLFzob6v4xCEKirddYiVeqwKWUI6bG/THp43Z4G/+WiEIRutcnXOH2FtdO8lQpkPReHIOpWm7yOmr8O0Bn9tI6EOGHkZZzWJy8EA/cGFO82gK7vbex+8lkfJMRjdCCurRJM/SYB8g6n2TpOmdfzCOKVpJ93euTo3xZP4HJWIgvhpHkAEyLNt02djYZiyd8APGihCnkr4bB5fWU8qzb7Vk8BdMaS3QQ0WAS4AcJx89eMhlXFp04BRBJ9a6TMfF8CgL637SeIVsGZsQxoH4DHS9IrEiyYHn2t2XtmCoCZKRJPXWDw/U4mtVH7nKr4Hv5vKr0mG4mnGiXLuI1JHJSil1TFe3gGQHv7oQULq249D9AyBzPbIX1hZPjOB4LBtVNXtjNuaCKJ1GYp5VE7sjilQUI819pY/0VW/4YrplAs+R2AWqcMlKRL9KXa5N0wXSMHQKoakPrKvLikZPYHD41PiFVtO2fuhnNe8oXimpcgNH12st+HJUUJgWfURt83s6PzGgzHe99m5jZL6WwOYuD1gOLryCVb4AkzheOpY8y80WY/ZuUOqYpP/xdAzlZwiPT0nPGMTFxMAfys2aw29deWL+XNfr8/YwlAD4pGo5Vp17Ik+P+GIG1keMmW7HxvGUAP1DTNNTiMHmZ6xaYnW0zm4MjwwI5gMKhfchdspmaZUDy5C0zvAOzU3w3SYKhqs+9gMeN5F7JigZ1dfbWUyeir9V3F+pr7nQYl06ZdzfWnzcSZqkBWeF+sb0kFyTjsm6EOT3q4ZfZphxEQSwBZ4UhcWy+Z3rP8NUf4lSB2tDbVnzRi1uQ6YEyy/eRJ96Jz/7zIzLsBNvZZyjwAQfuXV/EnhaZIIw5KqsD0BPq2IxTrXUOELQDXATTr44jPg/TjG3lUbfL/YMSckT62AcxOFo1qVdIt7pYZN1eQvKQoz+snH7a3fwHw4Np47XWUFQAAAABJRU5ErkJggg=="
								alt="" class="encode-image">
							<span class="encode-font">已加密</span>
						</span>
					</div>

				</van-form>
			</div>
		</div>

		<div class="pay-button">
			<div class="footer-container">
				<div class="price">
					<span class="price-now">
						<label>
							<span class="price-unit">￥</span>
							<span>0</span>
						</label>
					</span>
				</div>
				<div class="jonit-content">
					<van-button class="btn-jonit" :loading="isLoading" type="primary" @click="onSubmit">免费报名</van-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import md5 from "js-md5";
	import { format } from '@/utils.js'
	export default {
		data() {
			return {
				phone: '',
				isLoading:false
			}
		},
		created() {
			console.log();
		},
		methods: {
			phoneValidator(val) {
				return /^1[34578]\d{9}$/.test(val)
			},
			onSubmit() {
				const gt = new Date().getTime().toString();
				this.$refs.vanForm.validate().then(res => {
					this.isLoading = true;
					this.$API.createEnroll({
						mobile: this.phone,
						time:gt,
						encryPwd: md5(gt + 'verify'),
						...this.$route.query
					}).then(res => {
						this.phone = '';
						this.$router.replace('/active1/result');
					}).finally(() => {
						this.isLoading = false;
					})
				})
			}
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	.bind-phone {
		height: 100vh;
		background-color: #f2f4f7;

		.form-item {
			display: flex;
			background-color: #fff;

			.is-encode {
				display: flex;
				justify-content: center;
				align-items: center;
				flex: 0 0 auto;
				margin-right: 0.2rem;

				.encode-image {
					height: .3rem;
					width: .25rem;
				}

				.encode-font {
					margin-left: .1rem;
					font-size: .2708rem;
					color: #778494;
					line-height: normal;
					font-weight: 400;
				}
			}
		}
	}

	.content-card {
		border-radius: .208rem;
		padding: 0.3rem;
	}

	.footer-container {
		position: fixed;
		left: 0;
		bottom: 0;
		z-index: 9;
		width: 100%;
		background: #fff;
		padding-bottom: env(safe-area-inset-bottom);
		box-shadow: 0 -1px 5px 0 rgba(51, 51, 51, .10196078431372549);
		box-sizing: border-box;
		height: 1.25rem;
		display: flex;
		padding: 0 0.3375rem;

		.jonit-content {
			display: flex;
			justify-content: center;
			align-items: center;

			.btn-jonit {
				width: 3.875rem;
				height: 0.91rem;
				box-shadow: 0 2px 5px 0 rgba(255, 70, 43, .4);
				border-radius: 0.5rem;
				font-size: 0.41rem;
				font-weight: 500;
				color: #fff;
				background: linear-gradient(90deg, #ff622c, #ff2a2a);
				border: none;
				&:disabled{
					box-shadow: 0 2px 5px 0 rgba(199, 199, 199, 0.4);
					background: linear-gradient(90deg, #dfdfdf, #dfdfdf);
				} 
			}
		}

		.price {
			display: flex;
			height: 100%;
			flex: 1;
			align-items: center;
			color: #020822;
			font-size: .25rem;

			.price-now {
				color: #ff382e;
				font-size: 0.66rem;

				.price-unit {
					color: #ff382e;
					font-size: 0.375rem;
				}
			}
		}
	}
</style>
